import { SVGProps, Ref, forwardRef } from 'react';

export const UserCircleOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.998 3.666c-2 0-2.666 1.333-2.666 2.666s.666 2.666 2.666 2.666 2.666-1.333 2.666-2.666-.667-2.666-2.666-2.666M6.99 5.396c-.141.17-.258.478-.258.936s.117.767.258.937c.104.125.345.33 1.008.33s.903-.205 1.007-.33c.141-.17.259-.478.259-.937 0-.458-.118-.767-.259-.936-.104-.125-.344-.33-1.007-.33s-.904.205-1.008.33"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5-1.875 7.5-7.5 7.5S.5 11.75.5 8m1.4 0c0-1.667.42-3.184 1.316-4.26C4.076 2.71 5.524 1.9 8 1.9s3.924.81 4.784 1.84C13.68 4.816 14.1 6.333 14.1 8s-.42 3.184-1.316 4.26q-.254.306-.58.579c-.588-2.097-2.397-2.84-4.206-2.84s-3.617.742-4.206 2.837a4.5 4.5 0 0 1-.576-.576C2.319 11.184 1.9 9.667 1.9 8m3.156 5.59c.77.317 1.735.51 2.944.51 1.207 0 2.17-.192 2.94-.509-.134-.798-.464-1.265-.81-1.554-.496-.413-1.24-.639-2.132-.639s-1.636.226-2.132.64c-.346.288-.676.754-.81 1.552"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
UserCircleOutlinedSize16Glyph.displayName = 'UserCircleOutlinedSize16Glyph';
